import PropTypes from 'prop-types';
// @mui
import { styled } from '@mui/material/styles';
import * as React from 'react';
import { useEffect } from 'react';
import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';
import { Stack, AppBar, Toolbar, IconButton, Grid } from '@mui/material';
// utils
import { bgBlur } from '../../../utils/cssStyles';
// components
import Iconify from '../../../components/iconify';
//
import LanguagePopover from './LanguagePopover';

import AccountPopover from './AccountPopover';

// ----------------------------------------------------------------------

const NAV_WIDTH = 300;
const HEADER_MOBILE = 60;
const HEADER_DESKTOP = 90;

const StyledRoot = styled(AppBar)(({ theme }) => ({
  ...bgBlur({ color: theme.palette.background.default }),
  boxShadow: 'none',
  height: `${HEADER_MOBILE}px`,
  ...(theme.breakpoints.up('lg') && {
    height: `${HEADER_DESKTOP}px`,
    width: `calc(100% - ${NAV_WIDTH + 1}px)`,
  }),
  backgroundColor: 'transparent', // Add this line to make it always transparent
  '&:hover': {
    backgroundColor: 'transparent',
  },
}));

const StyledToolbar = styled(Toolbar)(({ theme }) => ({
  minHeight: HEADER_MOBILE,
  [theme.breakpoints.up('lg')]: {
    minHeight: HEADER_DESKTOP,
    padding: theme.spacing(0, 5),
  },
}));

// ----------------------------------------------------------------------

Header.propTypes = {
  onOpenNav: PropTypes.func,
};

export default function Header({ onOpenNav }) {
  return (
    <StyledRoot>
      <StyledToolbar>
        <IconButton
          onClick={onOpenNav}
          sx={{
            mr: 1,
            color: 'text.primary',
            display: { sm: 'none' },
          }}
        >
          <Iconify icon="eva:menu-2-fill" />
        </IconButton>

        <Grid container direction={'row'} style={{ placeContent: 'space-between' }}>
          <Grid item>
            <LanguagePopover />
          </Grid>
          <Grid item>
            {' '}
            {/* <Alert severity="warning">
              There {totaldata === 1 ? 'is ' : 'are'}
              {totaldata >= 1 ? totaldata : ' no'} Outstanding {totaldata === 1 ? 'Alert' : 'Alerts'}
            </Alert> */}
          </Grid>
          <Grid item>
            {' '}
            <AccountPopover />
          </Grid>
        </Grid>
      </StyledToolbar>
    </StyledRoot>
  );
}
